import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function InsiderIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" fill="none" {...props}>
      <Box
        as="path"
        fill="#000"
        d="M8.85.25c-4.5.99-7.57 4.79-7.56 9.36.01 3.7 2.04 6.94 5.36 8.54 1.28.62 2.25.86 3.75.92 1.52.06 2.76-.16 4.02-.72.46-.2.89-.37.96-.38.07-.01.29.27.49.63.65 1.18.5 1.26 1.58-.9.53-1.06.94-1.94.92-1.96-.02-.03-.96-.03-2.09-.02l-2.06.03.44.75c.24.41.44.78.44.83 0 .12-1.1.6-2 .88-.66.21-.95.24-2.35.24-1.77 0-2.34-.12-3.82-.8-3.36-1.55-5.47-5.33-5.04-9.02A9.102 9.102 0 0 1 8.51.93c.91-.25 3.57-.25 4.48 0 1.61.44 2.81 1.15 4.03 2.38.96.95.98.97 1.19.8.21-.17.21-.17-.3-.77C16.62 1.82 14.67.69 12.58.25c-.85-.18-2.9-.18-3.73 0Z"
      />
      <Box
        as="path"
        fill="#000"
        d="M6.598 9.3v5h1.8v-10h-1.8v5ZM13.2 7.09c-.56.18-1.1.53-1.41.91l-.34.4.03-.6.04-.6H9.7v7.1h1.78l.04-2.03c.03-1.86.05-2.06.26-2.49.53-1.08 1.96-1.53 2.63-.82.24.25.24.27.27 2.8l.03 2.54h1.8l-.03-2.78-.03-2.77-.28-.58c-.39-.79-.91-1.09-1.96-1.13-.42-.02-.87 0-1.01.05Z"
      />
    </Icon>
  );
}
